import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { openWindowCentered } from '../site';
import { PProFetch } from '../ajax';

function dateSorter(a, b){
	return(new Date(a).getTime() - new Date(b).getTime());
}
export default function RecentOrders(props) {
	const { refreshSignal, CacheKey } = props;
	const cache = JSON.parse(window.localStorage.getItem("ecom_RecentOrders_AccountDashboardHandler.getrecentorders"));
	const cacheStamp = cache ? Date.parse(cache.stamp) : null;
	const localKey = cache ? cache.key : null;
	const [fpInfo, setFpInfo] = useState({
		root: {
			postUrl: null,
			submitCommand: null,
			WAREHOUSELABEL: null,
			customCRED: null,
			hideAMNT: null,
			hideCHILD: null,
			hideCRED: null,
			hideCREDCOL: null,
			hideEDITORDERS: null,
			hideINVNO: null,
			hidePONO2: null,
			hideSHIPDATE: null,
			hideSHIPTO: null,
			hideSUBCUST: null,
			hideWHSE: null,
			orderlistHEADER: null,
		},
		rowData: {
			/*
			AMNT
			CHILD
			CRED
			DETAILURL
			DLDT
			DLDTDESC
			FDATE
			INVNOVAL
			hideADDONBUTTON
			hideEDITBUTTON
			PONO
			PONO2
			PTAG
			SHIPDATE
			SHIPTO
			SHORTSTATUS
			SONO
			STATUS
			SUBCUST
			WHSE
			customCRED
			*/
		}
	});
	const [tableView, setTableView] = useState({
		field: "",
		ascending: false,
		suffixes: []
	});
	const [loading, setLoading] = useState(true);

	const updateStateFromAjax = (json) => {
		setFpInfo({...json});
		setLoading(false);
		setTableView({
			...tableView,
			suffixes: Object.keys(json.rowData)
		});
	}

	useEffect(() => {
		setLoading(true);
		if (
			/* if manual refresh signal is incremented, refresh */
			refreshSignal > 0 ||
			(	/* or if cache is too old, refresh */
				!cacheStamp || ((new Date() - cacheStamp) > (5*60*1000))
			) || (
				/* or if cache key has changed, refresh */
				!localKey || localKey != CacheKey
			)
		) {
			PProFetch("command=AccountDashboardHandler.getrecentorders")
			.then(response => {
				return response.json();
			})
			.then(json => {
				updateStateFromAjax(json);
				window.localStorage.setItem("ecom_RecentOrders_AccountDashboardHandler.getrecentorders", JSON.stringify({
					stamp: new Date(),
					key: CacheKey,
					data: {...json}
				}));
			});
		} else {
			updateStateFromAjax(cache.data);
		}
	}, [refreshSignal]);


	const submitFormHandler = (_) => {
		setLoading(true);
		const formData = new URLSearchParams();
		formData.append("command", fpInfo.root.submitCommand);
		///...
		PProFetch(fpInfo.root.postUrl, {
			method: "POST",
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: formData
		}).then(response => {
			return response.json();
		}).then(json => {
			updateStateFromAjax(json);
		}).catch(err => {
			console.error(err);
		});
	}

	const openSODetailHandler = (url, sono) => {
		openWindowCentered(url, `Sales order ${sono}`, false);
	}

	const addOnBtnHandler = (sono, dldt, subcustomer, profiletag) => {
		return () => {
			Ecom2.gaAddOnOrder();
			Ecom2.PProLoading.show();
			window.location=`${fpInfo.root.postUrl}?command=orderaddon.modify&sono=${sono}&action=A&dldt=${dldt}&scus=${subcustomer}&setotype=Y&ptag=${profiletag}`;
		}
	}

	const editBtnHandler = (sono, dldt, subcustomer, profiletag) => {
		return () => {
			Ecom2.gaEditOrder();
			Ecom2.PProLoading.show();
			window.location=`${fpInfo.root.postUrl}?command=orderaddon.modify&sono=${sono}&action=E&dldt=${dldt}&scus=${subcustomer}&ptag=${profiletag}`;
		}
	}

	const sortCol = (field) => {
		let ascending = false;
		if (tableView.field === field) {
			ascending = !tableView.ascending;
		}
		const suffixes = Object.keys(fpInfo.rowData);
		let sortedData = suffixes.map((suffix) => ({data: fpInfo.rowData[suffix], suffix}));
		let compare = (a, b) => {
			let aval = a.data[field].value;
			let bval = b.data[field].value;
			if (aval.startsWith("$") && bval.startsWith("$")) {
				// dollar amount comparison
				let afval = parseFloat(aval.substring(1));
				let bfval = parseFloat(bval.substring(1));
				if (afval < bfval) return ascending ? -1 : 1;
				if (afval > bfval) return ascending ? 1 : -1;				
			} else {
				// string comparison
				if (aval < bval) return ascending ? -1 : 1;
				if (aval > bval) return ascending ? 1 : -1;
			}
			return 0;
		};
		sortedData.sort(compare);
		const newSortSuffixes = [];
		for (let i = 0; i < sortedData.length; i++) {
			newSortSuffixes[i] = sortedData[i].suffix;
		}
		//console.log(newSortSuffixes);
		setTableView({
			field,
			ascending,
			suffixes: newSortSuffixes
		});
	}

	const tableFilter = (event) => {
		const val = event.target.value;
		if (!val || !val.trim()) {
			//clear, buggy
			setTableView({
				...tableView,
				suffixes: Object.keys(fpInfo.rowData)
			});
		}
		let sortedData = [];
		for (let [suffix, rowData] of Object.entries(fpInfo.rowData)) {
			for (let field of Object.values(rowData)) {
				if (field.value && field.value.toLowerCase().includes(val.toLowerCase())) {
					sortedData.push(suffix);
					break;
				}
			}
		}
		setTableView({
			...tableView,
			suffixes: sortedData
		});
	}

	let table = null;
	if (loading) {
		table = (<Skeleton count={5} height="45px"/>);
	}
	else {
		const rows = new Array();
		for (let suffix of tableView.suffixes) {
			const thisRowData = fpInfo.rowData[suffix];
			rows.push(
				<tr className="order" id={thisRowData.SONO.value} key={thisRowData.SONO.value}>
					<td
						className={`${fpInfo.root.hideCHILD.value} order__child`}
						>{thisRowData.CHILD.value}</td>
					<td
						className="order__sono"
						><a
							href="#"
							onClick={() => { openSODetailHandler(thisRowData.DETAILURL.value, thisRowData.SONO.value) }}
							>{thisRowData.SONO.value}<span
								className={`${fpInfo.root.hideCRED.value} ${fpInfo.root.customCRED.value} credit`}
								>{thisRowData.CRED.value}</span>
						</a>
					</td>
					<td
						className={`${fpInfo.root.hideSUBCUST.value} subcust order__subcust`}
						>{thisRowData.SUBCUST.value}</td>
					<td
						className={`${fpInfo.root.hideCREDCOL.value} order__credit`}
						>{thisRowData.CRED.value}</td>
					<td
						className="order__po"
						>{thisRowData.PONO.value}</td>
					<td
						className={`${fpInfo.root.hidePONO2.value} order__po2`}
						>{thisRowData.PONO2.value}</td>
					<td
						className="order__deliverydate text-end"
						>{thisRowData.DLDT.value}</td>
					<td
						className={`${fpInfo.root.hideAMNT.value} order__total text-end`}
						>{thisRowData.AMNT.value}</td>
					<td
						className="order__status"
						>{thisRowData.SHORTSTATUS.value}</td>
					<td
						className={`${fpInfo.root.hideSHIPDATE.value} order__shipdate`}
						>{thisRowData.SHIPDATE.value}</td>
					<td
						className={`${fpInfo.root.hideINVNO.value} order__invoiceno`}
						>{thisRowData.INVNOVAL.value}</td>
					<td
						className={`${fpInfo.root.hideSHIPTO.value} order__destination`}
						>{thisRowData.SHIPTO.value}</td>
					<td
						className={`${fpInfo.root.hideWHSE.value} order__warehouse`}
						>{thisRowData.WHSE.value}</td>
					<td
						className={`${fpInfo.root.hideEDITORDERS.value} order__utility text-center`}
						><div
							className="d-flex align-items-center justify-content-left">
							<button
								className={`${thisRowData.hideADDONBUTTON.value} button button--icon button--outline`}
								onClick={addOnBtnHandler(thisRowData.SONO.value, thisRowData.FDATE.value, thisRowData.SUBCUST.value, thisRowData.PTAG.value)}>
								<svg version="1.1" className="icon plus" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="349.03px" height="349.031px" viewBox="0 0 349.03 349.031" xmlSpace="preserve">
									<path className="fill-primary" d="M349.03,141.226v66.579c0,5.012-4.061,9.079-9.079,9.079H216.884v123.067c0,5.019-4.067,9.079-9.079,9.079h-66.579 c-5.009,0-9.079-4.061-9.079-9.079V216.884H9.079c-5.016,0-9.079-4.067-9.079-9.079v-66.579c0-5.013,4.063-9.079,9.079-9.079 h123.068V9.079c0-5.018,4.069-9.079,9.079-9.079h66.579c5.012,0,9.079,4.061,9.079,9.079v123.068h123.067 C344.97,132.147,349.03,136.213,349.03,141.226z"/>
								</svg>
							</button>
							<button 
								className={`${thisRowData.hideEDITBUTTON.value} button button--icon button--outline`}
								onClick={editBtnHandler(thisRowData.SONO.value, thisRowData.FDATE.value, thisRowData.SUBCUST.value, thisRowData.PTAG.value)}>
								<svg version="1.1" className="icon wrench" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 19.5 18.1" xmlSpace="preserve">
									<path className="fill-primary" d="M18.7,4.1c0-0.4-0.3-0.6-0.6-0.2l-1.7,1.6c-0.3,0.3-0.9,0.3-1.2,0l-1.7-1.6c-0.3-0.3-0.3-0.8,0-1.1l1.7-1.6 c0.3-0.3,0.2-0.6-0.3-0.6c0,0-2.5-0.1-3.8,1.1C9.8,2.8,9.5,4.5,10,6L7.8,8.1C7.1,8.7,6,9.7,5.3,10.4l-4.1,3.9 c-0.7,0.6-0.7,1.7,0,2.3L1.7,17c0.7,0.6,1.8,0.6,2.4,0l4.1-3.9C8.9,12.5,9.5,12,9.5,12c0,0,0.5-0.5,1.2-1.1l2.2-2.1 c1.6,0.5,3.4,0.1,4.6-1C18.8,6.5,18.7,4.1,18.7,4.1z M3.9,16.3c-0.5,0.5-1.4,0.5-1.9,0c-0.5-0.5-0.5-1.3,0-1.8 c0.5-0.5,1.4-0.5,1.9,0C4.5,14.9,4.5,15.8,3.9,16.3z"></path>
								</svg>
							</button>
						</div>
					</td>
				</tr>
			);
		}
		table = (
			<table className="table">
				<thead className="bg-color--light">
					<tr>
						<th
							className={`sort ${fpInfo.root.hideCHILD.value} order__child`}
							scope="col"
							onClick={() => sortCol("CHILD")}>Child company</th>
						<th
							className="sort order__sono"
							scope="col"
							onClick={() => sortCol("SONO")}>Sales order</th>
						<th
							className={`sort ${fpInfo.root.hideSUBCUST.value} subcust order__subcust`}
							scope="col"
							onClick={() => sortCol("SUBCUST")}>Sub cust.</th>
						<th
							className={`${fpInfo.root.hideCREDCOL.value} order__credit`}
							scope="col"
							onClick={() => sortCol("CRED")}></th>
						<th
							className="sort order__po"
							scope="col"
							onClick={() => sortCol("PONO")}>PO number #1</th>
						<th
							className={`sort ${fpInfo.root.hidePONO2.value} order__po2`}
							scope="col"
							onClick={() => sortCol("PONO2")}>PO number #2</th>
						<th
							className="sort order__deliverydate text-end"
							scope="col"
							onClick={() => sortCol("FDATE")}>Receiving date</th>
						<th
							className={`sort ${fpInfo.root.hideAMNT.value} order__total text-end`}
							scope="col"
							onClick={() => sortCol("AMNT")}>Total</th>
						<th
							className="sort order__status"
							scope="col"
							onClick={() => sortCol("SHORTSTATUS")}>Status</th>
						<th
							className={`sort ${fpInfo.root.hideSHIPDATE.value} order__shipdate`}
							scope="col"
							onClick={() => sortCol("SHIPDATE")}>Shipped</th>
						<th
							className={`sort ${fpInfo.root.hideINVNO.value} order__invoiceno`}
							scope="col"
							onClick={() => sortCol("INVNOVAL")}>{fpInfo.root.INVNODESC?.value}</th>
						<th
							className={`sort ${fpInfo.root.hideSHIPTO.value} order__destination`}
							scope="col"
							onClick={() => sortCol("SHIPTO")}>Ship to</th>
						<th
							className={`sort ${fpInfo.root.hideWHSE.value} order__warehouse`}
							scope="col"
							onClick={() => sortCol("WHSE")}>{fpInfo.root.WAREHOUSELABEL.value}</th>
						<th
							className={`${fpInfo.root.hideEDITORDERS.value} order__utility text-center`}
							scope="col">Add On/Edit Order</th>
					</tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
			</table>
		);
	}
	return (
		<React.Fragment>
			<div className="blocktext font-size--l mt-4">Recent Orders</div>
			<div className="form__instructions text-color--gray4">
				Click on the Sales Order Number to view the <b>order detail</b>.
				Sales orders marked with an '<span className="credit">*</span>' have credits applied.
			</div>
			<br/>
			<div className="d-flex justify-content-end mb-md1">
				<div className="search__wrapper border rounded-3 border-gray3 position-relative">
					<input id="results_search" type="text" className="input--small border-0 bg-transparent ps-3 pe-5 py-2" placeholder="Search orders" onChange={(e) => tableFilter(e)}/>
					<button type="submit" className="search-submit position-absolute top-50 translate-middle-y pe-2">
						<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 38.6 38.6" xmlSpace="preserve">
							<path className="primary" d="M25.8,23.6c2.1-2.6,3.2-5.8,3.2-9.1C29,6.5,22.5,0,14.5,0S0,6.5,0,14.5S6.5,29,14.5,29c3.3,0,6.5-1.2,9.1-3.2 l12.9,12.9l2.1-2.1L25.8,23.6z M14.5,3C20.8,3,26,8.2,26,14.5S20.8,26,14.5,26S3,20.8,3,14.5S8.2,3,14.5,3z"></path>
						</svg>
					</button>
				</div>
			</div>
			<div className="order__view table__wrapper overflow-auto">
				{table}
			</div>
		</React.Fragment>
	);
}